// extracted by mini-css-extract-plugin
export default {"header":"GenericDialog_header__8Wdj0","body":"GenericDialog_body__Aryfk","footer":"GenericDialog_footer__SNvJr"};